module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"react","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 0
// module chunks = 0